/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kiotviet_Link_SuccessInputs */

const vi_kiotviet_link_success = /** @type {(inputs: Kiotviet_Link_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã nối sản phẩm`)
};

/**

* @param {Kiotviet_Link_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const kiotviet_link_success = /** @type {((inputs?: Kiotviet_Link_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kiotviet_Link_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_kiotviet_link_success(inputs)
});